<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt />
      </a>
      <!-- <a class="menu_btn" href="javascript:;" @click="$router.push('more')">
        <img src="../assets/img/menu.png" alt />
      </a> -->
    </div>
    <div class="box"></div>
    <div class="title-bj">
      <div class="titleTop">{{detail.title}}</div>
      <div class="priceBox">
        <span
          class="span"
        >会议时间：{{startTime.slice(0,startTime.length - 8)}}~ {{endTime.slice(0,endTime.length - 8)}}</span>
        <!-- <span v-if="detail.fareType == 0" class="TicketPrice">票价：￥{{detail.fare}}</span> -->
        <!-- <span v-if="detail.fareType == 1" class="TicketPrice">定金：￥{{detail.fare}}</span> -->
        <span class="span">地点：{{detail.region}}</span>
      </div>
    </div>
    <!-- <div class="titlebox">
      <span class="iosimg" v-if="isiOS"></span>
      <span class="androidimg" v-if="isAndroid"></span>
      <span class="wximg" v-if="isWx"></span>
      <span class="title">{{detail.title}}</span>
      <span
        class="time"
      >时间：{{startTime.slice(0,startTime.length - 8)}}-{{endTime.slice(0,startTime.length - 8)}}</span>
      <span class="place">地点：{{detail.region}}</span>
    </div>-->
<!--    <div class="checkedIcon">-->
<!--      <van-cell-group>-->
<!--        <van-switch-cell v-model="checked" title="是否开具发票" />-->
<!--      </van-cell-group>-->
<!--      &lt;!&ndash; <span class="fapiao">是否开具发票</span>-->
<!--      <van-switch class="switch" v-model="checked" size="22px" />&ndash;&gt;-->
<!--      <van-cell v-if="checked" is-link @click="showPopup">发票信息</van-cell>-->
<!--      &lt;!&ndash; <van-switch class="switch" :value="checked" @input="onInput" size="22px" /> &ndash;&gt;-->
<!--    </div>-->
    <div>
      <mt-popup v-model="showpop" position="bottom" popup-transition="popup-fade" class="popupfade">
        <div class="boxbox">
          <div class="fadebox">
            <span class="fademsg">发票信息</span>
          </div>
          <div v-if="sliderShow" class="fadeplaceholder">
            <span class="sliderIn">企业发票</span>
            <span class="Gap"></span>
            <span class="sliderOut" @click="sliderbtn">个人发票</span>
          </div>
          <div v-if="!sliderShow" class="fadeplaceholder">
            <span class="sliderOut" @click="sliderbtn">企业发票</span>
            <span class="Gap"></span>
            <span class="sliderIn">个人发票</span>
          </div>
          <div class="inp fadeinp">
            <span class="lable">发票抬头</span>
            <div class="hidden">
              <input
                class="input"
                placeholder="请填写发票抬头"
                type="text"
                v-model="searchValue"
                @input="textVal"
                @blur="animateWidth()"
              />
              <ul class="ulShow" v-if='ulShow'>
                <li v-for="(item,i) in options" :key="i" @click="liClick">{{item.enName}}</li>
              </ul>
              <!-- <el-select
                class="width"
                v-model="searchValue"
                filterable
                remote
                @click="selectClick"
                @blur="animateWidth()"
                @change="currentSel($event)"
                :remote-method="remoteMethod"
                placeholder="请填写发票抬头"
              >
                <el-option
                  class="opt"
                  v-for="item in options"
                  :key="item.id"
                  :label="item.enName"
                  :value="item.id"
                ></el-option>
              </el-select> -->
            </div>
          </div>
          <div v-if="sliderShow" class="inp fadeinp">
            <span class="lable">企业税号</span>
            <div class="hidden">
              <input
                type="tel"
                class="input"
                placeholder="请填写企业税号"
                v-model="enIdentity"
                @blur="animateWidth()"
              />
            </div>
          </div>
          <div class="inp fadeinp">
            <span class="lable">接收邮箱</span>
            <div class="hidden">
              <input
                class="input"
                placeholder="请填写接收邮箱"
                type="email"
                v-model="email"
                @blur="animateWidth()"
              />
            </div>
          </div>
          <div class="btn">
            <span class="button" @click="fadebtn">确定</span>
            <span class="tips">预计下单后15天内开具</span>
          </div>
        </div>
      </mt-popup>
    </div>
    <div class="msgbox">
      <span class="participatingEnterprises">参会企业</span>
      <span class="enterprise">{{enterprise}}</span>
      <span class="participants">参会人员</span>
      <div v-for="item in msg" :key="item.id" class="msgboxin">
        <msgshow :item="item"></msgshow>
      </div>
    </div>
<!--    <div class="titlebox">-->
<!--      <span class="iosimg" v-if="isiOS"></span>-->
<!--      <span class="androidimg" v-if="isAndroid"></span>-->
<!--      <span class="wximg" v-if="isWx"></span>-->
<!--      <span class="title">支付方式</span>-->
<!--      <div class="wechartBoxF">-->
<!--        <span class="wechartBox">-->
<!--          <img class="wechart" src="../assets/img/wechatpay_ICON@2x.png" alt />-->
<!--        </span>-->
<!--        <span class="weTxt">微信</span>-->
<!--        <span class="wechartBtn" @click="wechartchoose">-->
<!--          <img v-if="wechartBtn" class="choose" src="../assets/img/pay_highlighted@2x.png" alt />-->
<!--          <img v-if="!wechartBtn" class="choose" src="../assets/img/pay_normal@2x.png" alt />-->
<!--        </span>-->
<!--      </div>-->
<!--      <div class="wechartBoxF">-->
<!--        <span class="wechartBox">-->
<!--          <img class="wechart" src="../assets/img/visa_ICON@2x.png" alt />-->
<!--        </span>-->
<!--        <span class="weTxt">线下支付</span>-->
<!--        <span class="wechartBtn" @click="wechartchoose">-->
<!--          <img v-if="!wechartBtn" class="choose" src="../assets/img/pay_highlighted@2x.png" alt />-->
<!--          <img v-if="wechartBtn" class="choose" src="../assets/img/pay_normal@2x.png" alt />-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
    <div class="wenjuan" v-if="wenjuan">
      <span class="iosimg" v-if="isiOS"></span>
      <span class="androidimg" v-if="isAndroid"></span>
      <span class="wximg" v-if="isWx"></span>
      <span class="jiantou" @click="show">
        <img
          class="jiantouimg"
          src="../assets/img/huiyiJiantou.png"
          alt
          :class="[rotate ?' go':' aa']"
        />
      </span>
      <span class="titlewenjuan">调查问卷</span>
      <div v-for="item in surveyReqDTO" :key="item.id">
        <transition name="fade">
          <div v-if="wenjuanShow">
            <span v-if="item.type == 0">
              <span class="questionName">{{item.questionName}}</span>
              <span class="wenjuanTxt" v-for="item in item.answers" :key="item.id">{{item.content}}</span>
            </span>
            <span v-if="item.type == 1">
              <span class="questionName">{{item.questionName}}</span>
              <span
                class="wenjuanTxt text-wrapper"
                v-for="item in item.answers"
                :key="item.id"
              >{{item.content}}</span>
            </span>
            <span v-if="item.type == 2">
              <!-- <span>
              <img src alt>
              </span>-->
              <span class="questionName">{{item.questionName}}</span>
              <span class="wenjuanTag" v-for="item in item.answers" :key="item.id">
                <span class="xuanXiang">
                  <img src="../assets/img/huiyiChoose.png" alt />
                </span>
                {{item.optionName}}
              </span>
            </span>
            <span v-if="item.type == 3">
              <span class="questionName">{{item.questionName}}</span>
              <span class="wenjuanTag" v-for="item in item.answers" :key="item.id">
                <span class="xuanXiang">
                  <img src="../assets/img/huiyiChoose.png" alt />
                </span>
                {{item.optionName}}
              </span>
            </span>
          </div>
        </transition>
      </div>
    </div>
    <div class="btnBox">
      <div class="btn1">
        <span class="total">合计：￥{{totalFare}}</span>
        <span class="discount">优惠：￥{{apiTicketReqestDTO.discount}}</span>
        <span class="button1" @click="btn">报名</span>
      </div>
    </div>
  </div>
</template>
<script>
import msgshow from './msgshow'
export default {
  data () {
    return {
      detail: '',
      enterprise: '',
      isiOS: false,
      isAndroid: false,
      isWx: false,
      startTime: '',
      endTime: '',
      msg: [],
      enrollId: '',
      enrollAttendeesReqDTO: {},
      showBox: -1,
      rotate: false,
      wenjuan: false,
      surveyReqDTO: [],
      wenjuanShow: false,
      popupVisible: false,
      email: '',
      checked: false,
      showpop: false,
      sliderShow: true,
      wechartBtn: true,
      type: '',
      people: '',
      apiTicketReqestDTO: {},
      enIdentity: '',
      searchValue: '',
      options: [],
      allOrds: {},
      list: [],
      obj: {},
      totalFare: '',
      wxRes: '',
      ulShow: false
      // bottom_tip: true
    }
  },

  components: {
    msgshow: msgshow
  },
  created () {
    this.content()
  },
  mounted () {
    this.download()
  },
  methods: {
    liClick (e) {
      this.ulShow = false
      // this.$refs.liText.
      console.log('e.target.innerText', e.target.innerText)
      let txt = e.target.innerText
      // e.target.innerText
      this.searchValue = e.target.innerText
      this.obj = this.options.find((item) => { // 这里的userList就是上面遍历的数据源
        return item.enName === txt// 筛选出匹配数据
      })
      console.log('obj', this.obj)
      this.enIdentity = this.obj.id
    },
    // 下拉搜索企业抬头
    textVal () {
      this.ulShow = false
      console.log('sssss', this.searchValue)
      if (this.searchValue.length < 2) return
      this.$axios
        .get('/pub/common/enterprise?enName=' + this.searchValue)
        .then(res => {
          if (res.code === 200) {
            this.allOrds = res.data.enterpriseList
            this.list = this.allOrds.map(item => ({
              enName: item.enName,
              id: item.enIdentity
            }))
            this.options = this.list.filter(
              item => item.enName.toLowerCase().indexOf(this.searchValue.toLowerCase()) > -1
            )
            this.ulShow = true
          }
        })
    },
    async remoteMethod (query) {
      if (query == '') return
      await this.$axios
        .get('/pub/common/enterprise?enName=' + query)
        .then(res => {
          if (res.code === 200) {
            this.allOrds = res.data.enterpriseList
            console.log('resssss', this.allOrds)
            this.list = this.allOrds.map(item => ({
              enName: item.enName,
              id: item.enIdentity
            }))
          }
        })

      if (query !== '') {
        // this.options = this.list
        // this.loading = true
        // this.loading = false

        this.options = this.list.filter(
          item => item.enName.toLowerCase().indexOf(query.toLowerCase()) > -1
        )
      }
    },
    currentSel (id) {
      this.enIdentity = id
      this.obj = this.options.find((item) => { // 这里的userList就是上面遍历的数据源
        return item.id === id// 筛选出匹配数据
      })
      console.log(this.obj.enName)// 获取的 name
      console.log(id)// 获取的 id
    },
    // 微信、线下Radio
    wechartchoose () {
      this.wechartBtn = !this.wechartBtn
    },
    // 个人、企业发票btn
    sliderbtn () {
      this.sliderShow = !this.sliderShow
    },
    // 发票信息确定按钮
    fadebtn () {
      let titleType
      if (this.sliderShow) {
        titleType = 1
      } else {
        titleType = 2
      }
      const invoiceDTO = {
        contentId: this.$route.query.contentId,
        enrollId: this.enrollId,
        invoiceType: 1,
        titleType: titleType,
        invoiceTitle: this.obj.enName,
        tfn: this.enIdentity,
        invoiceVal: this.totalFare,
        email: this.email
      }
      this.$axios
        .postJson(`/api/web/phone/enroll/invoice`, invoiceDTO)
        .then(res => {
          if (res.code == 200) {
            console.log('res', res)
            this.showpop = false
          } else {
            console.log('res', res)
            this.MessageBox.alert(res.message).then(action => {})
          }
        })
    },
    // 调出发票弹窗
    showPopup () {
      this.showpop = true
    },
    // 问卷显示与否
    show () {
      // console.log("id", id);
      // this.showBox = id;
      this.wenjuanShow = !this.wenjuanShow
      this.rotate = !this.rotate
    },

    // 光标失焦
    animateWidth () {
      setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
      }, 100)
    },
    // 判断ios android
    download () {
      // console.log('fasd ', this.$route)
      let ua = navigator.userAgent.toLowerCase()
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 // android终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isWeixinBrowser()) {
        this.isWx = !this.isWx
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // ios
          this.isiOS = true
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // android
          this.isAndroid = true
        }
      }
      function isWeixinBrowser () {
        return !!/micromessenger/.test(ua)
      }
    },
    async btn () {
      if (!this.checked) {
        let needInvoice
        if (this.checked) {
          needInvoice = 1
        } else {
          needInvoice = 0
        }
        let offlinePayDTO = {
          needInvoice: needInvoice,
          enrollId: this.enrollId,
          totalFare: this.totalFare
        }
        console.log('offlinePayDTO', offlinePayDTO)
        this.$axios
          .postJson(`/api/web/phone/enroll/offlinePay`, offlinePayDTO)
          .then(res => {
            if (res.code == 200) {
              console.log('res', res)
              this.$router.push({
                path: `/share`,
                query: {
                  contentId: this.$route.query.contentId,
                  categoryId: this.$route.query.categoryId,
                  parentId: this.$route.query.parentId
                }
              })
            } else {
              console.log('res', res)
              this.MessageBox.alert(res.data.message).then(action => {
                this.totalFare = res.data.totalFare
              })
            }
          })
      } else {
        let apiTicketReqestDTO = JSON.parse(
          localStorage.getItem('apiTicketReqestDTO')
        )
        apiTicketReqestDTO.enrollId = this.enrollId
        this.enrollAttendeesReqDTO = {
          enrollId: this.enrollId,
          apiTicketReqestDTO: apiTicketReqestDTO
        }
        console.log('dto', this.enrollAttendeesReqDTO)
        await this.$axios
          .postJson(`/api/web/phone/enroll/conform`, this.enrollAttendeesReqDTO)
          .then(res => {
            if (res.code == 200) {
              console.log('res', res)
            // this.$router.push({
            //   path: `/share`,
            //   query: {
            //     contentId: this.$route.query.contentId,
            //     categoryId: this.$route.query.categoryId,
            //     parentId: this.$route.query.parentId
            //   }
            // })
            } else {
              console.log('res', res)
              this.MessageBox.alert(res.data.message).then(action => {
                this.totalFare = res.data.totalFare
              })
            }
          })
        let needInvoice
        if (this.checked) {
          needInvoice = 1
        } else {
          needInvoice = 0
        }
        const wxpPayDTO = {
          needInvoice: needInvoice,
          enrollId: this.enrollId,
          totalFare: apiTicketReqestDTO.totalFare
        }
        await this.$axios
          .postJson(`/api/web/phone/enroll/wxpay`, wxpPayDTO)
          .then(res => {
            console.log('ressssssssssss', res)
            if (res.code == 200) {
              console.log('res', res)
              const {appid, timestamp, noncestr, sign} = res.data.wxRes
              this.wxRes = res.data.wxRes
              wx.config({
                debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: appid, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: noncestr, // 必填，生成签名的随机串
                signature: sign, // 必填，签名，见附录1
                jsApiList: ['scanQRCode', 'chooseWXPay'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              })
              alert('zhifu')
              wx.ready(() => {
                alert(this.wxRes.appid)
                alert(this.wxRes.sign)
                wx.chooseWXPay({
                  appId: this.wxRes.appid,
                  timestamp: this.wxRes.timestamp,
                  nonceStr: this.wxRes.noncestr,
                  package: 'prepay_id=' + this.wxRes.prepayid,
                  signType: 'MD5',
                  paySign: this.wxRes.sign,
                  success: function (res) {
                    alert(111)
                  }
                })
              })
            // function onBridgeReady () {
            //   WeixinJSBridge.invoke(
            //     'getBrandWCPayRequest', {
            //       'appId': 'wx2421b1c4370ec43b', // 公众号名称，由商户传入
            //       'timeStamp': '1395712654', // 时间戳，自1970年以来的秒数
            //       'nonceStr': 'e61463f8efa94090b1f366cccfbbb444', // 随机串
            //       'package': 'prepay_id=u802345jgfjsdfgsdg888',
            //       'signType': 'MD5', // 微信签名方式：
            //       'paySign': '70EA570631E4BB79628FBCA90534C63FF7FADD89' // 微信签名
            //     },
            //     function (res) {
            //       if (res.err_msg == 'get_brand_wcpay_request:ok') {
            //         // 使用以上方式判断前端返回,微信团队郑重提示：
            //         // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            //       }
            //     })
            // }
            // if (typeof WeixinJSBridge === 'undefined') {
            //   if (document.addEventListener) {
            //     document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
            //   } else if (document.attachEvent) {
            //     document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
            //     document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
            //   }
            // } else {
            //   onBridgeReady()
            // }
            } else {
              console.log('res', res)
              this.MessageBox.alert(res.message).then(action => {})
            }
          })
      }
    },
    wxPay () {

    },
    content () {
      this.detail = JSON.parse(localStorage.getItem('detail'))
      console.log(this.detail)
      if (this.$router.from === '/questionnaire') {
        this.wenjuan = true
      }
      if (this.detail.contentId.toString() !== this.$route.query.contentId) {
        window.location.href = window.location.href.replace('msg', 'singup')
      } else {
        this.endTime = this.detail.endTime
        this.startTime = this.detail.startTime
        this.msg = JSON.parse(localStorage.getItem('msg'))
        this.apiTicketReqestDTO = JSON.parse(
          localStorage.getItem('apiTicketReqestDTO')
        )
        this.totalFare = this.apiTicketReqestDTO.totalFare

        this.enterprise = localStorage.getItem('names')
        this.enrollId = localStorage.getItem('enrollId')
        this.people = localStorage.getItem('peoples')
        this.answer()
        const fenxiangdizhi = window.location.href.replace('msg', 'singup')
        this.wxShare(
          this.detail.title,
          this.detail.description,
          this.detail.thumbApp,
          fenxiangdizhi
        )
      }
    },
    answer () {
      const haveSurvey = localStorage.getItem('haveSurvey')
      if (haveSurvey !== 'false') {
        this.$axios
          .get(
            `/api/web/phone/survey/answer/${this.detail.contentId}/${this.enrollId}`
          )
          .then(res => {
            // console.log('res', res)
            if (res.code == 200) {
              this.surveyReqDTO = res.data.questions
              this.wenjuan = true
            }
          })
      }
    },
    onInput (checked) {
      console.log('checked', checked)
      this.checked = checked
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.ulShow {
  overflow: scroll;
  width: 86%;
  position: absolute;
  z-index: 1001;
  border: 1px solid #e4e7ed;
  border-radius: 1.067vw;
  background-color: #fff;
  -webkit-box-shadow: 0 0.533vw 3.2vw 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.533vw 3.2vw 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 1.333vw 0;
  overflow: scroll;
  max-height: 280px !important;
  top: 210px !important;
  li{
    margin: 10px 15px;
  }
}
.opt {
}
.width {
  width: 100%;
  /deep/ .el-input__inner {
    border: none;
    background-color: #f6f6f6;
    height: 27px;
  }
}
.body {
  padding-bottom: 150px;
}
.wechartBtn {
  position: absolute;
  bottom: 6px;
  right: 15px;
  width: 22px;
  margin-left: 15px;
  img {
    width: 100%;
    height: auto;
  }
}
.weTxt {
  position: absolute;
  font-size: 14px;
  color: #737373;
  left: 60px;
  bottom: 13px;
}
.wechartBoxF {
  position: relative;
}
.wechartBox {
  display: block;
  width: 36px;
  margin-left: 15px;
  margin-top: 12px;
  img {
    width: 100%;
    height: auto;
  }
}
.hidden {
  border-radius: 7px;
  overflow: hidden;
  margin-bottom: 12px;
}
.tips {
  margin-top: 10px;
  font-size: 12px;
  color: #bcbcbc;
}
.input {
  position: relative;
  width: 100%;
  height: 27px;
  background: #f6f6f6;
  padding-left: 16px;
  line-height: normal;
}
.inp {
  text-align: left;
  margin: 0 27px 0 27px;
}
::-webkit-input-placeholder {
  /* 使用webkit内核的浏览器*/
  font-size: 14px;
  color: #bcbcbc;
}
::-moz-placeholder {
  /* Firefox版本4-18 */
  font-size: 14px;
  color: #bcbcbc;
}
::-moz-placeholder {
  /* Firefox版本19+ */
  font-size: 14px;
  color: #bcbcbc;
}
::-ms-input-placeholder {
  font-size: 14px;
  color: #bcbcbc;
}

.lable {
  display: block;
  font-size: 12px;
  color: #bcbcbc;
  margin-bottom: 6px;
}
.Gap {
  display: inline-block;
  width: 18px;
}
.sliderIn {
  display: inline-block;
  font-size: 14px;
  color: #ffffff;
  width: 143px;
  height: 32px;
  line-height: 32px;
  background: #56c0ff;
  box-shadow: 0 3px 9px 0 rgba(76, 179, 240, 0.29);
  border-radius: 8px;
  margin-top: 5px;
}
.sliderOut {
  display: inline-block;
  font-size: 14px;
  color: #bcbcbc;
  width: 143px;
  height: 32px;
  line-height: 32px;
  margin-top: 5px;
}
.fadeplaceholder {
  height: 42px;
  background-color: #f6f6f6;
  margin: 0 27px;
  border-radius: 7px;
  margin-bottom: 36px;
}
.fadebox {
  margin-top: 15px;
  margin-bottom: 38px;
  font-size: 17px;
  font-weight: 700;
}
.popupfade {
  border-radius: 12px 12px 0px 0px;
  width: 100%;
  // padding-bottom: 200px;
  height: 500px;
}
.van-hairline--top-bottom:after {
  border: none;
}
.switch {
  position: absolute;
  right: 10px;
}
.fapiao {
  padding: 0 18px;
}
.checkedIcon {
  position: relative;
  text-align: left;
  width: 346px;
  background: #ffffff;
  border-radius: 7px;
  margin: 2px auto;
  border: 1px solid transparent;
  padding-bottom: 7px;
  padding: 5px 0;
}

// 后台数据回车字符
.text-wrapper {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.xuanXiang {
  display: inline-block;
  vertical-align: top;
  width: 15px;
  margin-right: 5px;
  margin-top: 1px;
  img {
    width: 100%;
    height: auto;
  }
}
.wenjuanTxt {
  display: block;
  font-size: 13px;
  color: #797979;
  margin-left: 25px;
  padding-right: 16px;
}
.wenjuanTag {
  display: block;
  font-size: 13px;
  color: #797979;
  margin-left: 18px;
  padding-right: 16px;
}
.questionName {
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #232323;
  margin-left: 18px;
  padding-top: 11px;
  padding-bottom: 5px;
}

.wenjuan {
  position: relative;
  width: 346px;
  // height: 102px;
  background: #ffffff;
  border-radius: 7px;
  margin: 18px auto;
  text-align: left;
  padding-bottom: 16px;
  .wximg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 21px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .iosimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 21px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .androidimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
}
.aa {
  transition: all 0.2s;
}
.go {
  transform: rotate(90deg);
  //  transform-origin: -.6px;
  transition: all 0.2s;
}

.jiantou {
  position: absolute;
  top: 16px;
  right: 17px;
  width: 10.2px;
  img {
    width: 100%;
    height: auto;
  }
}
.msgmb {
  display: block;
  font-size: 13px;
  color: #797979;
  margin-bottom: 9px;
}
.msgm {
  display: block;
  font-size: 13px;
  color: #797979;
  margin: 0 0 5px 0;
}
.msgname {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 4px 0;
  color: #232323;
}
.msgboxin {
  position: relative;
  padding: 0 18px;
}
.participants {
  display: block;
  font-size: 12px;
  margin: 18px 0 4px 18px;
  color: #797979;
}
.enterprise {
  display: block;
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 0 18px;
  color: #232323;
}
.participatingEnterprises {
  display: block;
  font-size: 12px;
  margin: 10px 0 4px 18px;
  color: #797979;
}
.msgbox {
  width: 346px;
  // height: 260px;
  background: #ffffff;
  border-radius: 7px;
  margin: 14px auto;
  text-align: left;
  border: 1px solid transparent;
  padding-bottom: 7px;
}
.time {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #797979;
  letter-spacing: 0;
  margin-left: 18px;
  padding-bottom: 9px;
}
.place {
  display: block;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #797979;
  letter-spacing: 0;
  margin-left: 18px;
  padding-bottom: 16px;
}
.titlebox {
  position: relative;
  width: 346px;
  // height: 102px;
  background: #ffffff;
  border-radius: 7px;
  margin: 14px auto;
  text-align: left;
  .wximg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .iosimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .androidimg {
    position: absolute;
    display: inline-block;
    width: 4px;
    height: 15px;
    top: 19px;
    left: 18px;
    background: #31aaf1;
    border-radius: 1px;
  }
}

.title {
  display: inline-block;
  margin: 16px 8px 9px 28px;
  font-size: 16px;
  font-weight: 700;
  color: #232323;
  letter-spacing: 0;
  vertical-align: top;
}
.priceBox {
  position: relative;
}
.TicketPrice {
  position: absolute;
  font-size: 12px;
  top: 0;
  right: 0;
}
.title-bj {
  padding: 26px;
  margin: 12px 4px 0 4px;
  min-height: 68px;
  background: url("../assets/img/dingdan_bg@3x.png");
  background-size: 100% 100%;
}
.span {
  text-align: left;
  font-size: 12px;
  display: block;
  margin-top: 8px;
}
.titleTop {
  text-align: left;
  font-weight: 700;
  // padding: 26px 26px 0 26px;
  font-size: 16px;
}
.titlewenjuan {
  display: inline-block;
  margin: 16px 8px 0 28px;
  font-size: 16px;
  font-weight: 700;
  color: #232323;
  letter-spacing: 0;
}

.box {
  height: 56px;
}

.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img{
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.btn {
  position: fixed;
  bottom: 24px;
  left: 105px;
  height: 60px;
  .button {
    display: block;
    color: #fff;
    width: 165px;
    height: 42px;
    font-size: 16px;
    line-height: 42px;
    background-image: linear-gradient(190deg, #5fd5f9 0%, #31aaf1 100%);
    box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
    text-align: center;
  }
}
.total {
  position: absolute;
  left: 30px;
  top: 24px;
  font-size: 16px !important;
  color: #666666;
}
.discount {
  position: absolute;
  left: 165px;
  top: 27px;
  font-size: 11px !important;
  color: #9f9f9f;
}
.btnBox {
  width: 100%;
  height: 72px;
  position: fixed;
  bottom: 5px;
}
.btn1 {
  box-sizing: border-box;
  -moz-box-sizing: border-box; /* Firefox */
  -webkit-box-sizing: border-box; /* Safari */
  display: block;
  margin: 0 9px;
  // width: 100%;
  background: url("../assets/img/jiage_BG@2x.png");
  background-size: 100% 100%;
  height: 72px;
  .button1 {
    position: absolute;
    top: 14px;
    right: 26px;
    color: #fff;
    width: 104px;
    height: 38px;
    font-size: 15px;
    line-height: 38px;
    background-image: linear-gradient(38deg, #ffe985 0%, #fa742b 100%);
    // box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
  }
}
</style>
<style>
.el-select-dropdown {
  position: absolute;
  z-index: 1001;
  border: 1px solid #e4e7ed;
  border-radius: 1.067vw;
  background-color: #fff;
  -webkit-box-shadow: 0 0.533vw 3.2vw 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.533vw 3.2vw 0 rgba(0, 0, 0, 0.1);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 1.333vw 0;
  overflow: scroll;
  max-height: 280px !important;
  top: 370px !important;
}
.el-select-dropdown__empty {
  height: 30px;
  line-height: 30px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/msg.vue